export default {"src":"/_next/static/media/ic_arrow_new_green.a5f2d0c4.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};